import { useEffect, useState } from "react";
import { Button } from "antd";
import { DisconnectOutlined, ReloadOutlined } from "@ant-design/icons";
import "./offline-screen.css";

export function useBrowserOnline() {
  const [online, setOnline] = useState(() =>
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const sync = () => setOnline(navigator.onLine);
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
    };
  }, []);

  return online;
}

const OfflineScreen = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="offline-screen" role="alert" aria-live="polite">
      <div className="offline-screen-inner">
        <DisconnectOutlined className="offline-screen-icon" aria-hidden />
        <h1 className="offline-screen-title">Отсутствует подключение к сети</h1>
        <p className="offline-screen-hint">
          Проверьте соединение и обновите страницу
        </p>
        <Button
          type="primary"
          size="large"
          icon={<ReloadOutlined />}
          onClick={handleRefresh}
        >
          Обновить
        </Button>
      </div>
    </div>
  );
};

export default OfflineScreen;
